import { Card, CardContent, Tooltip } from "@mui/material"
import { IMetaDataCard } from "../util/interface"
import { createUseStyles, useTheme } from "react-jss"
import info from "../icons/info.svg"
import MailActive from "../icons/email-active.svg"
import MailDisabled from "../icons/email-disabled.svg"
import CircularWithValueLabel from "./CustomProgress"
import CustomIcon from "./CustomIcon"

const useStyles = createUseStyles({
  wrapper: {
    fontFamily: ({ theme }: any) => theme.primaryFontFamily,
    display: "flex",
    flexDirection: "column",
    gap: 9,
  },
  headerWrapper: {
    display: "grid",
    gridTemplateColumns: "93% 7%",
    alignItems: "center",
    justifyContent: "center",
    height: 30,
    textAlign: "center",
  },
  header: {
    color: "#5C5C5C",
    fontSize: 12,
    justifySelf: "center",
    fontWeight: ({ activeTab, cardKey }: any) =>
      activeTab === cardKey ? "bolder" : "normal",
  },
  pass: {
    color: "#27AF8D",
    display: "flex",
    alignItems: "center",
  },
  fail: {
    color: "#E21824",
    display: "flex",
    alignItems: "center",
  },
  value: {
    color: "black",
  },
  info: {
    justifySelf: "flex-end",
  },
  stats: {
    fontSize: 14,
    display: "flex",
    gap: 10,
    alignItems: "center",
    justifyContent: "center",
  },
  progress: {
    display: "flex",
    justifyContent: "center",
    marginLeft: 20,
  },
  bodyWrapper: {
    display: "grid",
    gridTemplateColumns: "90% 10%",
  },
  email: {
    alignSelf: "flex-end",
  },
  card: {
    minWidth: 180,
    minHeight: 160,
    padding: 0,
    cursor: "pointer",
    boxShadow: ({ activeTab, cardKey }: any) =>
      activeTab === cardKey
        ? "0px 4px 8px 0px #2FD4CF4D"
        : "0px 2px 4px 0px #00000040",
    border: ({ activeTab, cardKey }: any) =>
      activeTab === cardKey ? "2px solid #2FD4CF66" : "2px solid #fff",
  },
  cardContent: {
    padding: 5,
  },
})

export const MetaDataCard = ({
  cardDetails,
  activeTab,
}: {
  cardDetails: IMetaDataCard
  activeTab: string
}) => {
  const theme: any = useTheme()

  const classes = useStyles({ theme, activeTab, cardKey: cardDetails.key })

  return (
    <Card className={classes.card}>
      <CardContent className={classes.cardContent}>
        <div className={classes.wrapper}>
          <div className={classes.headerWrapper}>
            <h3 className={classes.header}>{cardDetails.title}</h3>
            <Tooltip title={cardDetails.toolTipText}>
              <div className={classes.info}>
                <CustomIcon path={info}></CustomIcon>
              </div>
            </Tooltip>
          </div>
          <div className={classes.stats}>
            <div className={classes.pass}>
              <div>Passed: &nbsp;</div>
              <div className={classes.value}>{cardDetails.passCount}</div>
            </div>
            <div className={classes.fail}>
              <div>Failed: &nbsp;</div>
              <div className={classes.value}>{cardDetails.fail}</div>
            </div>
          </div>
          <div className={classes.bodyWrapper}>
            <div className={classes.progress}>
              <CircularWithValueLabel
                isActive={activeTab === cardDetails.key}
                isFull={cardDetails.progress === 100}
                progress={cardDetails.progress}
              />
            </div>
            <div className={classes.email}>
              {cardDetails.emailTrigger ? (
                <Tooltip title={cardDetails.emailText}>
                  <div>
                    <CustomIcon path={MailActive}></CustomIcon>
                  </div>
                </Tooltip>
              ) : (
                <CustomIcon path={MailDisabled}></CustomIcon>
              )}
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  )
}
